import React, { useState } from 'react';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { UserPageLecturerPricesRateAdd } from './componenets/user-page-lecturer-pricae-rate-add';
import { Dialog } from 'primereact/dialog';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';
import { Button } from 'primereact/button';
import globalUserPage from '../../../../stores/global-user-page';
import { observer } from 'mobx-react-lite';
import { UserPageLecturerRateItem } from './componenets/user-page-lecturer-rate-item';
import appApi from '../../../../api/app-api';

export interface UserPagePriceRate2Datamodel {
  user: UserSummaryType;
}

export const UserPagePriceRate2: React.FC<UserPagePriceRate2Datamodel> =
  observer(({ user }) => {
    const [addPriceRate, setAddPriceRate] = useState(false);

    const rates = globalUserPage.lecturerDetails?.rates3 || [];

    const refreshLecturerDetails = async () => {
      try {
        const lecturerDetails = await appApi.getUserLecturerDetails(user.id);
        globalUserPage.lecturerDetails = lecturerDetails.data.body;
      } catch (error) {
        console.error('Failed to refresh lecturer details:', error);
      }
    };

    return (
      <div
        style={{
          minHeight: '100vh',
          backgroundColor: '#F9FAFB',
          width: '100%',
        }}
      >
        <Button
          onClick={() => setAddPriceRate(true)}
          style={{ height: '30px' }}
          label={'הוספה'}
        />
        <div
          style={{
            maxWidth: '100%',
            margin: '0 auto',
            padding: '2rem 1rem',
          }}
        >
          {rates.length === 0 ? (
            <div
              style={{ textAlign: 'center', padding: '2rem', color: '#6B7280' }}
            >
              לא נמצאו תעריפים
            </div>
          ) : (
            <div>
              {rates.map((activity, index) => (
                <UserPageLecturerRateItem
                  key={index}
                  activity={activity}
                  index={index}
                  user={user}
                  onRefresh={refreshLecturerDetails}
                  shouldDisplayFinancials={true}
                />
              ))}
            </div>
          )}
        </div>

        <Dialog
          header="הוספת שרות למרצה"
          visible={addPriceRate}
          style={{
            width: '90wh',
            backgroundColor: 'white',
            padding: '8px',
            borderRadius: '8px',
          }}
          onHide={() => setAddPriceRate(false)}
        >
          <UserPageLecturerPricesRateAdd
            user={user}
            onHide={() => setAddPriceRate(false)}
          />
        </Dialog>
      </div>
    );
  });
